import axios from "axios";
import { BASE_URL } from "../../utils/urls";

const fetchUnreadMessageCountForStudent = async (token) => {
  const res = await axios.get(`${BASE_URL}/student/unread-notifications-count`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const fetchLatestNotification = async (token) => {
  const res = await axios.get(`${BASE_URL}/student/get-notifications`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const fetchNotification = async (notificationId, token) => {
  const res = await axios.get(`${BASE_URL}/student/read-notifications/${notificationId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};
export default fetchUnreadMessageCountForStudent;
